"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Box_1 = require("@nerdwallet/currency/components/Box");
var Link_1 = require("@nerdwallet/currency/components/Link");
var Text_1 = require("@nerdwallet/currency/components/Text");
var info_banner_module_css_1 = __importDefault(require("./info-banner.module.css"));
var nerdwallet_plus_logo_1 = require("../nerdwallet-plus-logo");
var InfoBanner = function (_a) {
    var ctaText = _a.ctaText, ctaLink = _a.ctaLink, text = _a.text;
    return (react_1.default.createElement(Box_1.Box, { alignItems: { desktop: "center", mobile: "flex-start" }, className: info_banner_module_css_1.default.container, flexDirection: { desktop: "row", mobile: "column" }, paddingBottom: 3, paddingTop: 3 },
        react_1.default.createElement(Box_1.Box, { display: "flex", flexDirection: { mobile: "row" }, width: 100 },
            react_1.default.createElement(Box_1.Box, { marginLeft: 3 },
                react_1.default.createElement(nerdwallet_plus_logo_1.NerdWalletPlusLogo, { width: 50, small: true })),
            react_1.default.createElement(Box_1.Box, { display: "flex", flexDirection: { desktop: "row", mobile: "column" }, justifyContent: "space-between", marginBottom: { desktop: 0, mobile: 2 }, marginLeft: 2, marginRight: { desktop: 0, mobile: 3 }, width: 100 },
                react_1.default.createElement(Text_1.Text, { tone: "positive", bold: true }, text),
                ctaLink ? (react_1.default.createElement(Box_1.Box, { marginTop: { desktop: 0, mobile: 3 }, marginLeft: 0, marginRight: { desktop: 3, mobile: 0 } },
                    react_1.default.createElement(Link_1.Link, { href: ctaLink, decorated: true },
                        react_1.default.createElement(Text_1.Text, { bold: true, tone: "assist" }, ctaText)))) : null))));
};
exports.default = InfoBanner;
